export const etapaLabel: Record<string, string> = {
  cadastro: 'Cadastro',
  analise: 'Em análise',
  coordenacao: 'Coordenação',
  tesouraria: 'Tesouraria',
  aguardando_ligacao: 'Aguardando ligação',
  aguardando_averbacao: 'Aguardando averbação',
  liquidado: 'Liquidado',
  devolvido: 'Devolvido',
  cancelado: 'Cancelado',
  inativo: 'Inativo',
};

export const etapaColor: Record<string, string> = {
  cadastro:             'bg-gray-100 text-gray-800',
  analise:              'bg-blue-100 text-blue-900',
  coordenacao:          'bg-indigo-100 text-indigo-900',
  tesouraria:           'bg-purple-100 text-purple-900',
  aguardando_ligacao:   'bg-amber-100 text-amber-900',
  aguardando_averbacao: 'bg-orange-100 text-orange-900',
  liquidado:            'bg-green-100 text-green-900',
  devolvido:            'bg-yellow-100 text-yellow-900',
  cancelado:            'bg-red-100 text-red-900',
  inativo:              'bg-gray-100 text-gray-500',
};

export const statusFinLabel: Record<string, string> = {
  pendente: 'pendente',
  em_pagamento: 'em pagamento',
  quitado: 'quitado',
  inadimplente: 'inadimplente',
  liquidado: 'liquidado',
};

export const statusFinColor: Record<string, string> = {
  pendente:     'bg-gray-100 text-gray-800',
  em_pagamento: 'bg-blue-100 text-blue-900',
  quitado:      'bg-green-100 text-green-900',
  inadimplente: 'bg-red-100 text-red-900',
  liquidado:    'bg-emerald-100 text-emerald-900',
};

export const origemLabel: Record<string, string> = {
  novo: 'Novo',
  renovacao: 'Renovação',
  refinanciamento: 'Refinanciamento',
  portabilidade: 'Portabilidade',
  migracao_etipi: 'Migração ETIPI',
};

export const parcelaStatusLabel: Record<string, string> = {
  aberta: 'aberta',
  paga: 'paga',
  parcial: 'parcial',
  atrasada: 'atrasada',
  cancelada: 'cancelada',
  renegociada: 'renegociada',
};

export const parcelaStatusColor: Record<string, string> = {
  aberta:      'bg-gray-100 text-gray-700',
  paga:        'bg-green-100 text-green-900',
  parcial:     'bg-amber-100 text-amber-900',
  atrasada:    'bg-red-100 text-red-900',
  cancelada:   'bg-gray-100 text-gray-500',
  renegociada: 'bg-purple-100 text-purple-900',
};
